import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import {
  PAGE_SIZE,
  MAX_SIZE,
  CURRENCY_SYB,
} from 'src/app/onelog/common/config/common';

@Component({
  selector: 'app-bank-authors',
  templateUrl: './bank-authors.component.html',
  styleUrls: ['./bank-authors.component.css'],
})
export class BankAuthorsComponent implements OnInit {
  constructor(private _requestService: RequestService) {}

  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  showSearchLoading: boolean = false;
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  Currency: any = CURRENCY_SYB;

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    //this.setSearching();
    this._requestService
      .getRequest('/contract_bank_authors')
      .subscribe((data: any) => {
        console.log(data);
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        //this.unsetSearching();
      });
  }

  getFilteredData(url: string, postData: any, urlParams: string) {
    this.setSearching();
    this._requestService
      .postRequest('/contract_bank_authors', postData, urlParams)
      .subscribe((data: any) => {
        //console.log(data);
        this.products = data.data;
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;

        this.unsetSearching();
      });
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    console.log(eventData);
    let urlParams = '?page=' + eventData.currentPage;
    this.getFilteredData('/contract_bank_authors', '', urlParams);
  }

  setSearching() {
    this.showSearchLoading = true;
  }

  unsetSearching() {
    this.showSearchLoading = false;
  }

  downloadReport() {
    let urlParams = '?is_download=1';

    this._requestService.download(
      '/contract_bank_authors',
      '',
      urlParams,
      `contract_bank_authors-${new Date().toLocaleString()}`
    );
  }
}
